export const getShowForm = (state) => state.backplane?.navigation?.showForm;

/**
 * @function getModalRecomputeFlag
 * @param {{ backplane: { navigation: {shouldRecomputeModal: boolean } }}} state
 * @return {boolean}
 */
export const getModalRecomputeFlag = (state) => state.backplane?.navigation?.shouldRecomputeModal;
